import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { TOAST_POSITION, BREAKPOINTS } from '@global/constants'
import { changeNameForLabel, TOKEN_HELPERS } from '@utils/helpers'
import { ButtonsContainer, ModalDataContainer } from '@global/styles'
import { spacing } from '@global/theme'

import { SolidButton } from '@components/button'
import { Dropdown, TextInput } from '@components/inputs/inputs'
import CustomDatePicker from '@components/datePicker'
import { useUser } from '@components/authentication/utils/hook'
import Toast from '@components/toast'
import { Text } from '@components/texts'
import { useWindowDimensions } from '@components/windowDimensions'

import SELECTORS_USER from '@components/authentication/redux/selectors'

import useRedux from '../../redux'

const EditEmploymentRecordProfile = ({ statuses, oldData, close, saveData }) => {
  useRedux()
  const { Logout } = useUser()
  const { device } = useWindowDimensions()

  const [initialPosition, setInitialPosition] = useState({
    name: '',
    value: oldData.initialPosition,
    error: ''
  })
  const [optionsStatuses, setOptionsStatuses] = useState()
  const [optionSelectedStatuses, setOptionSelectedStatuses] = useState(null)
  const [startDate, setStartDate] = useState(new Date(oldData.startDate))
  const [endDate, setEndDate] = useState(oldData.endDate ? new Date(oldData.endDate) : null)

  const [flag, setFlag] = useState(false)
  const [showButton, setShowButton] = useState(false)
  const [isShowing, setIsShowing] = useState(false)
  const [messageToast, setMessageToast] = useState({
    title: '',
    message: '',
    icon: '',
    color: ''
  })
  const [pegDatePaid, setPegDatePaid] = useState(oldData.endDate ? new Date(oldData.pegDatePaid) : null)

  const errorRefresh = useSelector(SELECTORS_USER.ERROR_USER_REFRESH)

  const handleDropdownChange = e => setOptionSelectedStatuses(e.value)

  const handleChange = val => setInitialPosition(val)

  const clearStates = () => {
    setInitialPosition({
      name: '',
      value: '',
      error: ''
    })
    setStartDate(null)
    setEndDate(null)
    setOptionSelectedStatuses(null)
  }

  const handleClick = () => {
    const newDataProfile = {
      billingNumber: oldData.billingNumber,
      initialPosition: initialPosition.value,
      statusId: optionSelectedStatuses.id,
      startDate: startDate.toISOString(),
      endDate: endDate ? endDate.toISOString() : null,
      pegDatePaid
    }
    saveData(newDataProfile)
    clearStates()
    close()
  }

  const errorControl = () => {
    if (flag) {
      if ((initialPosition.value && !initialPosition.error)
          && optionSelectedStatuses
          && (endDate
            ? (endDate?.setHours(0, 0, 0, 0) >= startDate?.setHours(0, 0, 0, 0))
            : startDate)) setShowButton(false)
      else setShowButton(true)
    }
  }

  useEffect(() => {
    setOptionsStatuses(changeNameForLabel(statuses))
    setOptionSelectedStatuses(changeNameForLabel(statuses).find(item => item.id === oldData.statusId))
  }, [])

  useEffect(() => {
    if (optionsStatuses) {
      setFlag(true)
    }
  }, [optionsStatuses])

  useEffect(() => {
    errorControl()
  }, [startDate, endDate, initialPosition, optionSelectedStatuses])

  useEffect(() => {
    if (errorRefresh) {
      TOKEN_HELPERS.EXPIRED_TOKEN(errorRefresh.message, setIsShowing, setMessageToast, Logout)
    }
  }, [errorRefresh])

  return (
    <>
      {flag
      && (
      <>
        <ModalDataContainer flexDirection='column'>
          <CustomDatePicker
            name='startDate'
            title='Fecha de ingreso'
            color='primary'
            date={startDate}
            onChange={setStartDate}
            yearsToShow={100}
            justifyContentButton='space-between'
            block
          />
          <CustomDatePicker
            name='endDate'
            title='Fecha de egreso'
            color='primary'
            date={endDate}
            onChange={setEndDate}
            yearsToShow={100}
            justifyContentButton='space-between'
            block
            empty={!endDate}
            isClearable
          />
          <TextInput
            label='Cargo'
            placeholder='Ingrese cargo'
            name='initialPosition'
            value={initialPosition.value}
            height='small'
            color='primary'
            onChange={handleChange}
          />
          <Dropdown
            name='status'
            label='Estado'
            placeholder='seleccione una opción'
            options={optionsStatuses}
            value={optionSelectedStatuses}
            onChange={handleDropdownChange}
            color='primary'
            height='small'
            block
          />
          {oldData.pegAmountPaid > 0
            && (
            <CustomDatePicker
              name='pegDatePaid'
              title='Fecha de pago PEG'
              color='primary'
              date={pegDatePaid}
              onChange={setPegDatePaid}
              yearsToShow={100}
              justifyContentButton='space-between'
              block
            />
            )}
        </ModalDataContainer>
        {(endDate && (startDate?.setHours(0, 0, 0, 0) > endDate?.setHours(0, 0, 0, 0)))
           && (
           <Text size='medium' weight='regular' align='left' color='error'>
             La fecha de ingreso no puede ser posterior a la fecha de engreso.
           </Text>
           )}
        <ButtonsContainer justifyContent='flex-end' marginTop={spacing.two}>
          <SolidButton
            size={device === BREAKPOINTS.MOBILE ? 'small' : 'medium'}
            color='primary'
            text='Guardar'
            onClick={handleClick}
            disabled={showButton}
            block={device === BREAKPOINTS.MOBILE}
          />
        </ButtonsContainer>
        <Toast
          title={messageToast.title}
          message={messageToast.message}
          color={messageToast.color}
          icon={messageToast.icon}
          isShowing={isShowing}
          position={TOAST_POSITION.leftTop}
          onClick={() => setIsShowing(false)}
        />
      </>
      )}
    </>
  )
}

export default EditEmploymentRecordProfile

EditEmploymentRecordProfile.propTypes = {
  close: PropTypes.func,
  statuses: PropTypes.array,
  saveData: PropTypes.func,
  oldData: PropTypes.object
}
